import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "7",
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.7364 0.363602C11.3849 0.0121312 10.8151 0.0121326 10.4636 0.363605L6.00002 4.82721L1.53639 0.363602C1.18492 0.0121312 0.615073 0.0121326 0.263602 0.363605C-0.0878685 0.715078 -0.0878675 1.28493 0.263605 1.6364L5.36363 6.7364C5.7151 7.08787 6.28495 7.08787 6.63642 6.73639L11.7364 1.63639C12.0879 1.28492 12.0879 0.715074 11.7364 0.363602Z",
  fill: "#6B6A74"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }